import type { FormSpyRenderProps } from "react-final-form";
import every from "lodash/every";
import includes from "lodash/includes";
import some from "lodash/some";

type FormCondition = (renderProps: FormSpyRenderProps) => boolean;

export const fieldIsValid =
  (fieldName: string) =>
  ({ form }: FormSpyRenderProps) => {
    const field = form && form.getFieldState(fieldName);
    return !field || !!field.valid;
  };

export const fieldHasTruthyValue =
  (fieldName: string) =>
  ({ form }: FormSpyRenderProps) => {
    const state = form.getFieldState(fieldName);
    return !!state && !!state.value;
  };

export const fieldHasValue =
  (fieldName: string, value: any) =>
  ({ form }: FormSpyRenderProps) => {
    const state = form.getFieldState(fieldName);
    return !!state && state.value === value;
  };

export const fieldHasValueIn =
  (fieldName: string, values: any[]) =>
  ({ form }: FormSpyRenderProps) => {
    const state = form.getFieldState(fieldName);
    return !!state && includes(values, state.value);
  };

export const fieldIsRegistered =
  (fieldName: string) =>
  ({ form }: FormSpyRenderProps) =>
    !!form.getFieldState(fieldName);

export const all =
  (...conditions: FormCondition[]) =>
  (formSpyRenderProps: FormSpyRenderProps) =>
    every(conditions, condition => condition(formSpyRenderProps));

export const not = (condition: FormCondition) => (formSpyRenderProps: FormSpyRenderProps) =>
  !condition(formSpyRenderProps);

export const atLeastOne =
  (...conditions: FormCondition[]) =>
  (formSpyRenderProps: FormSpyRenderProps) =>
    some(conditions, condition => condition(formSpyRenderProps));

export const fieldsAreValid = (fields: string[]) => (formSpyRenderProps: FormSpyRenderProps) =>
  every(fields, field => fieldIsValid(field)(formSpyRenderProps));
